import React from 'react'

import { Image } from '@chakra-ui/react'

const StackerImage = (props) => <Image maxW="100%" ignoreFallback {...props} />

export default React.memo(StackerImage)
